// const reviewsSecArr = document.querySelectorAll(".reviews-sec");
//
// if (reviewsSecArr.length) {
//
//   function isIOS() {
//     return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
//         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
//   }
//
//   reviewsSecArr.forEach(review => {
//     if (isIOS()) {
//       review.style.backgroundAttachment = 'scroll';
//     } else {
//       review.style.backgroundAttachment = 'scroll';
//     }
//   })
// }